(() => {
  let opener;
  const dialog = () => document.getElementById('partner-request');
  function open() {
    const panel = dialog();
    if (!panel || panel.open) return;
    document.querySelectorAll('.mobile-menu[open],.products-menu[open]').forEach(menu => {menu.open = false;});
    panel.showModal();
    document.documentElement.classList.add('partner-request-open');
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-partner-open]');
    if (trigger && dialog()) {event.preventDefault(); opener = trigger; open();}
    if (event.target.closest('[data-partner-close]')) dialog()?.close();
    const panel = dialog();
    if (panel && event.target === panel) {
      const rect = panel.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
    }
  });
  function init() {
    const panel = dialog();
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    panel.addEventListener('close', () => {
      document.documentElement.classList.remove('partner-request-open');
      opener?.focus();
    });
    if (['#partner-request', '#partner-form'].includes(location.hash) || panel.querySelector('[data-partner-result]')) open();
  }
  addEventListener('hashchange', () => {if (location.hash === '#partner-request') open();});
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => document.documentElement.classList.remove('partner-request-open'));
  init();
})();
